import { TextField as MuiTextField, Typography, Box } from "@mui/material";

const TextField = ({ label, id, name, value, onChange, type = "text", ...props }) => {
  return (
    <Box sx={{ width: "100%", mb: 1.5 }}>
      <Typography
        component="label"
        htmlFor={id}
        sx={{
          display: "block",
          mb: 1,
          fontWeight: "bold",
          color: "#333",
        }}
      >
        {label}
      </Typography>
      <MuiTextField
        fullWidth
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        size="small"
        sx={{
          "& .MuiInputBase-root": {
            height: "40px",
          },
        }}
        {...props}
      />
    </Box>
  );
};

export default TextField;
